import axios from "axios";
import * as types from "../mutation-types";
import store from "~/store";
import logger from "~/utilities/logger";

// state
export const state = {
  organization_list: [],
  managed_organizations: null,
  organization_select: null,
  the_id: null,
};

// getters
export const getters = {
  organization_list: (state) => state.organization_list,
  managed_organizations: (state) => state.managed_organizations,
  check_list: (state) => state.organization_list !== null,
  organization_select: (state) => state.organization_select,
  the_id: (state) => state.the_id,
};

//utils
export const getOrgIndexById = (state, orgId) =>
  state.organization_list.findIndex(
    (org) => org.org_id.toString() === orgId.toString()
  );
export const getOrgByOrgId = (state, orgId) =>
  state.organization_list.find(
    (org) => org.org_id.toString() === orgId.toString()
  );
export const isMyOrg = (state, orgId) =>
  state.managed_organizations.find(
    (org) => org.org_id.toString() === orgId.toString()
  );

// mutations
export const mutations = {
  [types.ADD_ORGANIZATION](state, location)
  {
    return state.location_list.push(location);
  },

  [types.FETCH_ORGANIZATIONS](state, { organization_list })
  {
    return (state.organization_list = organization_list);
  },

  [types.FETCH_MANAGED_ORGANIZATIONS](state, { organization_list })
  {
    return (state.managed_organizations = organization_list);
  },

  [types.FETCH_MANAGED_ORGANIZATIONS_FAILURE](state, error)
  {
    return logger.error("FETCH_MANAGED_ORGANIZATIONS_FAILURE");
  },

  [types.FETCH_ORGANIZATIONS_FAILURE](state)
  {
    return logger.error("FETCH_ORGANIZATIONS_FAILURE");
  },

  [types.FETCH_ORGANIZATION](state, { organization_select })
  {
    return (state.organization_select = organization_select);
  },

  [types.FETCH_ORGANIZATION_FAILURE](state, { error })
  {
    logger.error("FETCH_ORGANIZATION_FAILURE");
    logger.error(error);
  },

  [types.UPDATE_ORGANIZATION](state, { payload })
  {
    // state.organization_select = payload.act_id;
  },

  [types.SET_ORGANIZATION_ID](state, { id })
  {
    state.the_id = id;
  },

  [types.SELECT_ORGANIZATION](state, { org_id })
  {
    let theSelect = getOrgByOrgId(state, org_id);
    logger.log("store.SELECT_ORGANIZATION", theSelect);
    return (state.organization_select = theSelect);
  },

  [types.DESELECT_ORGANIZATION](state)
  {
    return (state.organization_select = null);
  },

  [types.DELETE_ORGANIZATION](state, { org_id })
  {
    logger.log("store.DELETE_ORGANIZATION", state, org_id);
    const index = getOrgIndexById(state, org_id);
    if (index === -1)
    {
      return console.warn(`Unable to delete organization (id ${org_id})`);
    }
    return state.organization_list.splice(index, 1);
  },

  [types.ARCHIVE_ORGANIZATION](state, { payload })
  {
    logger.log("store.ARCHIVE_ORGANIZATION", state, payload.org_id);
    const index = getOrgIndexById(state, payload.org_id);
    if (index === -1)
    {
      return console.warn(`Unable to archive organization (id ${payload.org_id})`);
    }
    state.organization_list[index] = payload;
    return state.organization_list;
  },
};

// actions
export const actions = {
  async getOrganizations({ commit }, payload)
  {
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";

    try
    {
      logger.log(
        "store.getOrganizations",
        `/api/organizations?paginate=${paginate}&format=${format}${extraOptions}`
      );
      const { data } = await axios.get(
        `/api/organizations?paginate=${paginate}&format=${format}${extraOptions}`
      );
      logger.log("store.getOrganizations rsp", data);
      return commit(types.FETCH_ORGANIZATIONS, {
        organization_list: data.data.data,
      });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_ORGANIZATIONS_FAILURE);
    }
  },

  async getManagedOrganizations({ commit }, payload)
  {
    // if (!payload.org_ids || !payload.org_ids[0]) return;
    let paginate = payload && payload.paginate ? payload.paginate : 10000;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    let format = payload && payload.format ? payload.format : "minimal";

    let organization_list = [];
    let managed_users = [];
    let managed_orgs = [];

    let filtered_org_ids = [];
    let userObj = null;
    if (await store.getters["auth/check"])
    {
      userObj = await store.getters["auth/user"];
    }

    if (!userObj || !userObj.hierarchy[0])
    {
      logger.error("if (!userObj || !userObj.hierarchy[0])");
      return;
    }

    if (!store.getters["organizations/check_list"])
    {
      await store.dispatch("organizations/getOrganizations");
    }
    organization_list = await store.getters["organizations/organization_list"];

    if (!store.getters["users/check_managed_users"])
    {
      await store.dispatch("users/getManagedUsers", {
        usr_ids: userObj.hierarchy.join(),
      });
    }
    managed_users = await store.getters["users/managed_users"];

    if (managed_users)
    {
      for (const user of managed_users)
      {
        if (user.org_id && filtered_org_ids.indexOf(user.org_id) === -1)
        {
          logger.log(
            "store.managed_users user organization with id ",
            user.org_id,
            user
          );
          filtered_org_ids.push(user.org_id);
          let theOrg = organization_list.find((x) => x.org_id === user.org_id);
          if (theOrg) managed_orgs.push(theOrg);
        } else
        {
          logger.error(
            "store.managed_users ",
            "user " +
            user.usr_firstname +
            "" +
            user.usr_lastname +
            " does not have org_id set"
          );
        }
      }
    }

    logger.error("store.getManagedOrganizations rsp", managed_orgs);
    logger.error("store.getManagedUsers rsp", managed_users);
    return commit(types.FETCH_MANAGED_ORGANIZATIONS, {
      organization_list: managed_orgs,
    });
  },

  async getOrganization({ commit, dispatch }, id)
  {
    try
    {
      const { data } = await axios.get(`/api/organizations/${id}`);
      logger.log("store.getOrganization", data);
      return commit(types.FETCH_ORGANIZATION, {
        organization_select: data.data,
      });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_ORGANIZATION_FAILURE, { error: e });
    }
  },

  async updateOrganization({ commit, dispatch }, payload)
  {
    try
    {
      const { data } = await axios.put(
        `/api/organizations/${payload.act_id}`,
        payload
      );
      logger.log("store.updateOrganization", data);
      return commit(types.UPDATE_ORGANIZATION, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.FETCH_ORGANIZATION_FAILURE, { error: e });
    }
  },

  setOrganizationID({ commit, dispatch }, id)
  {
    commit(types.SET_ORGANIZATION_ID, { id: id });
  },

  async selectOrganization({ commit, dispatch }, { org_id })
  {
    logger.log("store.selectOrganization", org_id);
    if (!store.getters["organizations/check_list"])
    {
      await store.dispatch("organizations/getOrganizations");
    }
    return commit(types.SELECT_ORGANIZATION, { org_id: org_id });
  },

  async deselectOrganization({ commit, dispatch })
  {
    logger.log("store.deselectOrganization");
    return commit(types.DESELECT_ORGANIZATION);
  },

  async deleteOrganization({ commit, dispatch }, payload)
  {
    if (!payload.org_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.delete(
        `/api/organizations/${payload.org_id}${extraOptions}`
      );
      logger.log("store.deleteOrganization rsp", data);
      return commit(types.DELETE_ORGANIZATION, { org_id: payload.org_id });
    } catch (e)
    {
      logger.log(e);
      return commit(types.DELETE_ORGANIZATION_FAILURE, e);
    }
  },

  async archiveOrganization({ commit, dispatch }, payload)
  {
    if (!payload.org_id) return;
    let extraOptions =
      payload && payload.extra_options ? payload.extra_options : "";
    try
    {
      const { data } = await axios.put(
        `/api/organizations/archive/${payload.org_id}${extraOptions}`
      );
      logger.log("store.archiveOrganization rsp", data);
      return commit(types.ARCHIVE_ORGANIZATION, { payload: data.data });
    } catch (e)
    {
      logger.log(e);
      return commit(types.ARCHIVE_ORGANIZATION_FAILURE, e);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
